import * as React from 'react';

import AdobeAcrobat32 from './AdobeAcrobat32';

export const adobeAcrobat32 = () => <AdobeAcrobat32 />;

export default {
    title: 'Icon/Logo/AdobeAcrobat32',
    component: AdobeAcrobat32,
    parameters: {
        notes: "`import AdobeAcrobat32 from 'box-ui-elements/es/icon/logo/AdobeAcrobat32';`",
    },
};
